var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 20.5C36.5 29.3366 29.3366 36.5 20.5 36.5C11.6634 36.5 4.5 29.3366 4.5 20.5C4.5 11.6634 11.6634 4.5 20.5 4.5C29.3366 4.5 36.5 11.6634 36.5 20.5ZM22.5 28.5C22.5 29.6046 21.6046 30.5 20.5 30.5C19.3954 30.5 18.5 29.6046 18.5 28.5C18.5 27.3954 19.3954 26.5 20.5 26.5C21.6046 26.5 22.5 27.3954 22.5 28.5ZM20.5 10.5C19.3954 10.5 18.5 11.3954 18.5 12.5V20.5C18.5 21.6046 19.3954 22.5 20.5 22.5C21.6046 22.5 22.5 21.6046 22.5 20.5V12.5C22.5 11.3954 21.6046 10.5 20.5 10.5Z",
    fill: "#FF3D30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotOk);
export default __webpack_public_path__ + "static/media/notOk.531a6b1f37d70d73a3121afa5639bd37.svg";
export { ForwardRef as ReactComponent };